export function toComputable(toConvert: string): number {
  const blacklist = /[^\d,.]/g;
  const converted = toConvert.replace(blacklist, '').replace(',', '.');
  return +converted;
}
